import { Box, CloseButton, ScrollArea, Stack } from "@mantine/core";
import Logo from "layout/header/Logo.jsx";
import { useLayout } from "provider";
import ListGroup, { NavButton } from "./ListGroup.jsx";
import { useTrans } from "core/index.js";
import { useNavigate } from "react-router";

const Navbar = ({ menu = [] }) => {
	const { options, toggleMobile } = useLayout();
	const { t } = useTrans();
	const navigate = useNavigate();
	const handleLogout = () => {
		try {
			localStorage.removeItem("token");
		} catch (e) {}
		navigate("/");
		// reload to refresh auth-dependent UI
		window.location.reload();
	};

	return (
		<Box variant="garient" className="bg-lightColor-3 dark:bg-darkColor-4 h-full grid grid-rows-[auto,1fr,auto]">
			{/* header */}
			<Stack w="100%" h={options.header.height} p={"md"}>
				<div className="flex items-center justify-between">
					<Logo />
					<CloseButton hiddenFrom="sm" onClick={toggleMobile} />
				</div>
				<hr className="mx-4 border-lightColor-7" />
			</Stack>
			{/* content */}
			<ScrollArea p="md" className="mt-4">
				<ListGroup items={menu} />
			</ScrollArea>
			{/* footer */}
			<div>
				<hr className="mx-4 border-lightColor-7" />
				<Stack p="md" gap={0}>
					{/* <NavButton icon="CogOutline" label={"settings"} /> */}
					<NavButton
						icon="Logout"
						label={t("drawer.LogOut")}
						onClick={handleLogout}
						chevron
						chevronProps={{ name: "ChevronUp", className: "rtl:-rotate-90 ltr:rotate-90" }}
					/>
				</Stack>
			</div>
		</Box>
	);
};

export default Navbar;
